import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewBuilderResaleList } from "../../Redux/Actions/builderResaleAction";
import "./listBuilder.css";
// import axios from "axios";
import { columnsBuildersResale } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListBuilders = () => {
  // const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const [dateRange, setDateRange] = useState({ sstart: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);


  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const builderData = {
      page,
      limit: pageSize,
      is_deleted: false,
      filter: debouncedSearch,
      // signup_from: "builder_panel",
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(viewBuilderResaleList(builderData, showLoader));

      if (!showLoader) {
        toast.success("Bookings list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh bookings list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  const { builderResaleList, loading } = useSelector((state) => state.buildersResale);
  console.log("datat",builderResaleList)

  useEffect(() => {
    if (builderResaleList?.total) {
      setPagination((prevData) => ({ ...prevData, total: builderResaleList.total }));
    }
  }, [builderResaleList]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  // const graphOptions = ["year", "month", "week"];
  // const [graphData, setGraphData] = useState({});

  // const [graphSelect, setGraphSelect] = useState({ type: "year" });

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  // useEffect(() => {
  //   const selectionGetGraphDataHandler = async (event) => {
  //     try {
  //       const response = await axios.post(
  //         `${BASE_URL}/builder/graph`,
  //         graphSelect,
  //         {
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       );
  //       if (response) {
  //         setGraphData(response.data.data);
  //       }
  //     } catch (error) {
  //       console.error("Error Loading Graph Data");
  //     }
  //   };
  //   selectionGetGraphDataHandler();
  // }, [dispatch, graphSelect, BASE_URL]);

  return (
    <MainLayout>
      <div className="dashboard-container">

        <div className="table_component_all">
          <ListTopSearch
            buttonhead={canAdd ? "Add Builder Resale" : null}
            navigateTo={canAdd ? "/builder_resale/add" : null}
            h3heading="Builders Resale List"
            setState={setSearchQuery}
            onCalendarClick={() => setIsDatePopupVisible(true)}
          ></ListTopSearch>
          <div style={{ overflowX: "auto", padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(builderResaleList?.data) ? builderResaleList.data : []}
              pagination={pagination}
              scroll={{ x: 1700, y: 500 }}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsBuildersResale}
              rowClassName={() => "text-center"}
            ></Table>
          </div>
        </div>
        <DateRangePopup
          visible={isDatePopupVisible}
          initialStart={dateRange.start}
          initialEnd={dateRange.end}
          onCancel={() => setIsDatePopupVisible(false)}
          onOk={handleDateRangeApply}
        />
      </div>
    </MainLayout>
  );
};

export default ListBuilders;
